export class RCR {
  numberOfContacts: number;

  numberOfRepeatContacts: number;

  finalized: boolean;

  lastUpdated: string;

  repeatContactRate: number;

  constructor({
    numberOfContacts,
    numberOfRepeatContacts,
    finalized,
    lastUpdated,
    repeatContactRate,
  }: Record<string, any>) {
    this.numberOfContacts = numberOfContacts;
    this.numberOfRepeatContacts = numberOfRepeatContacts;
    this.finalized = finalized;
    this.lastUpdated = lastUpdated;
    this.repeatContactRate = repeatContactRate;
  }
}

export const EmptyRCR: RCR = {
  numberOfContacts: 0,
  numberOfRepeatContacts: 0,
  finalized: false,
  lastUpdated: '',
  repeatContactRate: 0,
};
